import * as constants from "./../constants";

export interface RequestResultsAction {
    type: constants.REQUEST_RESULTS;
  }

export interface ReceiveResultsAction {
    type: constants.RECEIVE_RESULTS;
    data: JSON;
    totals: JSON; 
  }
  
  export interface ReceiveResultsFailureAction {
    type: constants.RECEIVE_RESULTS_FAILURE;
    error: any;
  }

  export interface ReceiveColumnsFailureAction {
    type: constants.RECEIVE_COLUMNS_FAILURE;
    error: any;
  }

  export interface ReceiveFieldsFailureAction {
    type: constants.RECEIVE_FIELDS_FAILURE;
    error: any;
  }

  export function requestResults(): RequestResultsAction {
    return {
      type: constants.REQUEST_RESULTS,
    };
  }

  export function receiveResults(data: JSON, totals: JSON): ReceiveResultsAction {
    return {
      type: constants.RECEIVE_RESULTS,
      data,
      totals,
    };
  }

  export function receiveResultsFailure(error: any): ReceiveResultsFailureAction {
    return {
      type: constants.RECEIVE_RESULTS_FAILURE,
      error,
    };
  }

  export function receiveColumnsFailure(error: any): ReceiveColumnsFailureAction {
    return {
      type: constants.RECEIVE_COLUMNS_FAILURE,
      error,
    };
  }

  export function receiveFieldsFailure(error: any): ReceiveFieldsFailureAction {
    return {
      type: constants.RECEIVE_FIELDS_FAILURE,
      error,
    };
  }